<template>
  <div class="col-12">
    <div class="card card--profile-tasks">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="clearfix">
              <h3 class="float-start">
                <i
                  data-feather="toggle-left"
                  class="w-icon-24"
                /> Tasks
              </h3>
              <span class="float-end">
                <div
                  class="btn-group"
                  role="group"
                  aria-label="Basic radio toggle button group"
                >
                  <input
                    id="btnradio1"
                    type="radio"
                    class="btn-check"
                    name="btnradio"
                    autocomplete="off"
                    
                    @click="filter = 0"
                  >
                  <label
                    class="btn btn-sm btn-outline-secondary"
                    for="btnradio1"
                  >All</label>

                  <input
                    id="btnradio2"
                    type="radio"
                    class="btn-check"
                    name="btnradio"
                    autocomplete="off"
                    checked
                  >
                  <label
                    class="btn btn-sm btn-outline-secondary"
                    for="btnradio2"
                    @click="filter = 1"
                  >Pending</label>

                  <input
                    id="btnradio3"
                    type="radio"
                    class="btn-check"
                    name="btnradio"
                    autocomplete="off"
                  >
                  <label
                    class="btn btn-sm btn-outline-secondary"
                    for="btnradio3"
                    @click="filter = 2"
                  >Completed</label>
                </div>
              </span>
            </div>
            <hr>
            <template v-if="loading">
              <div
                class="loading custom-loading"
              >
                <div class="effect-1 effects" />
                <div class="effect-2 effects" />
                <div class="effect-3 effects" />
              </div>
            </template>
            <div
              v-else
              class="app-content  todo-application"
            >
              <div>
                <div class="content-right w-100">
                  <div class="content-wrapper">
                    <div class="content-header row" />
                    <div class="content-body">
                      <div class="body-content-overlay" />
                      <div class="todo-app-list">
                        <!-- Todo List starts -->
                        <div class="todo-task-list-wrapper list-group">
                          <ul
                            id="todo-task-list"
                            class="todo-task-list media-list"
                          >
                            <li
                              v-for="task in customTasks"
                              :key="task.alert_id"
                              class="todo-item"
                              :class="{'completed': task.done}"
                            >
                              <div class="todo-title-wrapper">
                                <div class="todo-title-area">
                                  <i
                                    data-feather="more-vertical"
                                    class="drag-icon"
                                  />
                                  <div class="title-wrapper">
                                    <div class="form-check">
                                      <input
                                        id="customCheck1"
                                        type="checkbox"
                                        class="form-check-input"
                                        :checked="task.done"
                                        @click="markTask(task, $event)"
                                      >
                                      <label
                                        class="form-check-label"
                                        for="customCheck1"
                                      />
                                    </div>
                                    <span>{{ task.title }}</span>
                                  </div>
                                </div>
                                <div class="todo-item-action">
                                  <div class="badge-wrapper me-1" />
                                  <small class="text-nowrap text-muted me-1">{{ task.date }}</small>
                                </div>
                              </div>
                              <p>
                                <small v-html="linkedText(task)" />
                                <template v-if="task.message && task.message.length > 200">
                                  <button
                                    v-if="!isExpanded(task)"
                                    class="btn btn-link p-0"
                                    @click="expandTask(task)"
                                    type="button"
                                  >
                                    Show more
                                  </button>
                                  <button
                                    v-else
                                    class="btn btn-link p-0"
                                    @click="collapseTask(task)"
                                    type="button"
                                  >
                                    Show less
                                  </button>
                                </template>
                              </p>
                            </li>
                          </ul>
                        </div>
                        <!-- Todo List ends -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      filter: 1,
      expandedTasks: {},
    }
  },
  computed: {
    ...mapGetters({
      loggedUser: 'auth/admin',
      alerts: 'alerts/tasks',
      loading: 'alerts/loading',
      filters: 'filters/filters',
      fields: 'modals/tableSettingsFields',
    }),
    tasks() {
      return this.alerts.data.data
    },
    customTasks() {
      return this.tasks.filter(e => {
        if (this.filter === 1) {
          return (e.done === false || e.done === null)
        }

        if (this.filter === 2) {
          return e.done === true
        }

        return true
      })
    },
  },
  async mounted() {
    await this.$store.dispatch('alerts/fetchTasks', {
      researcher: {id: this.loggedUser.id},
    })
  },
  methods: {
    async markTask(task, event) {
      await this.$store.dispatch('alerts/mark', task.alert_id)
      task.done = event.target.checked
    },
    isExpanded(task) {
      return !!this.expandedTasks[task.alert_id]
    },
    expandTask(task) {
      this.$set(this.expandedTasks, task.alert_id, true)
    },
    collapseTask(task) {
      this.$set(this.expandedTasks, task.alert_id, false)
    },
    linkedText(task) {
      const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g
      if (!task.message) return ''
      const max = 200
      const text = task.message
      const useFull = this.isExpanded(task) || text.length <= max
      const source = useFull ? text : text.slice(0, max)
      const replaced = source.replace(urlRegex, url => {
        let href = url
        if (!href.startsWith('http')) href = `https://${href}`
        return `<a href="${href}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline">${url}</a>`
      })
      return replaced + (!useFull && text.length > max ? '...' : '')
    },
  },
}
</script>
